export default __webpack_public_path__ + "static/PHNG-logo-e215ca1fdc0c918da3870d57afbdf051.svg";